import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ResetPassword.scss";
import { checkResetPasswordToken } from "services/user/userService";
import { PacmanLoader } from "react-spinners";
import Swal from "sweetalert2";
import { resetPassWord } from "services/user/userService";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [email, setEmail] = useState();

  useEffect(() => {
    const activateAccount = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const resetToken = params.get("reset-token");
        if (!resetToken) {
          alert("Không tìm thấy token reset. Vui lòng kiểm tra lại.");
          return;
        }
        setIsLoading(true);
        // Gọi API kích hoạt tài khoản
        const response = await checkResetPasswordToken(resetToken);
        console.log(response.data.data);
        if (response.status === 200) {
          setIsTokenValid(true);
          setEmail(response.data.data);
        }
      } catch (error) {
        console.log(error);
        if (error.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Liên kết không hợp lệ hoặc đã hết hạn!",
            text: "Vui lòng kiểm tra lại liên kết hoặc yêu cầu một liên kết mới",
            // timer: 5000,
            customClass: {
              popup: "my-swal", // Liên kết với lớp CSS
            },
          }).then(() => {
            navigate("/");
          });
        } else {
          //   setStatusMessage("Đã xảy ra lỗi khi kích hoạt tài khoản.");
        }
      } finally {
        setIsLoading(false);
      }
    };

    activateAccount();
  }, [location]);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      Swal.fire({
        icon: "error",
        // title: "Liên kết không hợp lệ hoặc đã hết hạn!",
        text: "Mật khẩu không khớp!",
        // timer: 5000,
        customClass: {
          popup: "my-swal", // Liên kết với lớp CSS
        },
      });
    } else {
      const response = await resetPassWord(email, confirmPassword);
      console.log("dat", response);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Đặt lại mật khẩu thành công!",
          text: "Mời bạn đăng nhập để tiếp tục!",
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: {
            popup: "my-swal", // Liên kết với lớp CSS
          },
        }).then(() => {
          navigate("/login");
        });
      }
    }
  };

  return (
    <div className="reset-password-container">
      {isTokenValid ? (
        <div className="reset-password-box">
          <h2>Đặt lại Mật khẩu</h2>

          <input
            type="password"
            id="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Nhập mật khẩu mới"
            required
          />

          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            placeholder="Xác nhận mật khẩu mới"
            required
          />

          {/* Nút xác nhận */}
          <button onClick={handleSubmit}>Xác nhận</button>
        </div>
      ) : (
        <div className="invalid-token-message">
          {/* <h2>Token không hợp lệ hoặc đã hết hạn</h2>
          <p>Vui lòng kiểm tra lại liên kết hoặc yêu cầu một liên kết mới.</p> */}
        </div>
      )}

      {isLoading && (
        <div className="modal">
          <div className="modal-content_loading">
            <PacmanLoader color="#5e2e86" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
